import { render, staticRenderFns } from "./dialog-actions.vue?vue&type=template&id=b9c6e41a"
import script from "./dialog-actions.vue?vue&type=script&lang=js"
export * from "./dialog-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports